import React from "react";
import ClubList from "../../Club/ClubList";

const Clubs = () => {
  return (
    <>
      <div className={"mb-2"}>
        <ClubList />
      </div>
    </>
  );
};

export default Clubs;
